// 全局组件
//设置默认的参数值，全局创建或销毁Toast的DIV
import React from 'react';
import ReactDOM from 'react-dom';
import Notification from './notification';

interface returnInfo {
    addNotice: (notice: any) => any;
    destory: () => void;
}
export interface NotificationApi {
    info(args: any): void;
    success(args: any): void;
    error(args: any): void;
    warning(args: any): void;
    open(args: any): void;
    close(args: any): void;
    config(options: any): void;
    destory(): void;
}
export type noticeInfo = {
    type?: string;
    content: string;
    duration?: string | number;
    onClose(): void;
};
function createNotification(): returnInfo {
    const div: HTMLDivElement = document.createElement('div');
    document.body.appendChild(div);
    const notification = ReactDOM.render((<Notification />) as any, div);
    return {
        addNotice(notice: any) {
            return (notification as any).addNotice(notice);
        },
        destory() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    };
}

// 定义一个全局的 notification 变量用于保存 createNotification 返回的对象
let notification: any;
const notice = ({
    type = 'info',
    content,
    duration = 2000,
    onClose,
}: noticeInfo) => {
    if (!notification) notification = createNotification();
    return notification.addNotice({ type, content, duration, onClose });
};

const api: any = {
    open() {},
    close(key: string) {},
    config() {},
    destory() {},
};
['info', 'success', 'error', 'warning'].forEach((type) => {
    api[type] = (args: any) => {
        return notice({ ...args, type });
    };
});
export default api as NotificationApi;
